import './main.less';
import { actions, selectors } from './';
import React from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import Form from './components/form';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content exchange-reports">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Currency exchange')}</h1>
						{
							props.isAddFormMode &&
							<Link className='link go_back' onClick={props.changeAddFormMode}>
								{props.intl('Return to list of rates')}
							</Link>
						}
					</div>
				</div>
				<div className="container__content-body">
					{
						!props.isAddFormMode &&
						props.can('edit') &&
						<button className="ui-btn ui-btn-primary edit-mode" onClick={props.changeAddFormMode}>
							{ props.intl('Add new') }
						</button>
					}
					{
						props.isAddFormMode ?
							<Form
								intl={props.intl}
								can={props.can}
								submitForm={props.submitForm}
								cancelForm={props.cancelForm}
								changeAddFormMode={props.changeAddFormMode}
								currenciesOptions={props.currenciesOptions}
								initialValues={{}}
							/>:
							<div className="exchange-table">
								<table>
									<thead>
										<td>{'id'}</td>
										<td>{'Created at'}</td>
										<td>{'Currency'}</td>
										<td>{'Buying rate (USD)'}</td>
										<td>{'Selling rate (USD)'}</td>
										<td>{'Type'}</td>
										<td>{'User'}</td>
									</thead>
									<tbody>
										{
											props.data.map((rt, index) => (
												<tr key={index}>
													<td>{rt.id}</td>
													<td>{rt.created_at}</td>
													<td>{rt.currency}</td>
													<td>{rt.buying_rate}</td>
													<td>{rt.selling_rate}</td>
													<td>{rt.type}</td>
													<td>{rt.admin_email}</td>
												</tr>
											))
										}
									</tbody>
								</table>
							</div>
					}
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		isAddFormMode: selectors.getAddFormMode(state),
		currenciesOptions: selectors.getCurrenciesOptions(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/exchange-rates/main.js